import React from 'react';
import { createGlobalStyle } from 'styled-components';
import GlobalCommonStyle from '@whitelabel/component-library/src/styled/GlobalStyle';
import globalTypeStyle from './globalTypeStyle';
import globalAccessibilityStyle from './globalAccessibilityStyle';

const GlobalRCSharedStyle = createGlobalStyle`
  ${globalTypeStyle}
  ${globalAccessibilityStyle}
`;

const GlobalStyle = () => (
  <>
    <GlobalCommonStyle />
    <GlobalRCSharedStyle />
  </>
);

export default GlobalStyle;
